/* import __COLOCATED_TEMPLATE__ from './auth-app.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { getOwner } from '@ember/application';
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { MarketQRCodeEncoder } from '@square/qrcode-encoder';
export const CONSTANTS = {
  DEFAULT_TWO_FACTOR_HELP_URL: '/help/en/us/article/5593-2-step-verification'
};
let TwoFactorEnrollAuthAppComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), _class = class TwoFactorEnrollAuthAppComponent extends Component {
  get unknownErrorTLabel() {
    return 'generic_errors.other.unknown';
  }
  get lockoutErrorTLabel() {
    return 'generic_errors.other.lockout';
  }
  get twoFactorHelpUrl() {
    return this.args.twoFactorHelpUrl || CONSTANTS.DEFAULT_TWO_FACTOR_HELP_URL;
  }
  get formattedManualQrCode() {
    if (!this.multipassfeClient.googleAuthDetails?.authenticator_key_base32) {
      return '';
    }
    return this.multipassfeClient.googleAuthDetails?.authenticator_key_base32.match(/.{1,4}/g).join('  ');
  }
  get disableNextAction() {
    return Boolean(this.initializingAuthAppEnrollSecret || this.error);
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "locale", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "logger", _descriptor3, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor4, this);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "views", Object.freeze({
      QR_CODE: 'QR_CODE',
      MANUAL: 'MANUAL'
    }));
    _initializerDefineProperty(this, "view", _descriptor5, this);
    _initializerDefineProperty(this, "initializingAuthAppEnrollSecret", _descriptor6, this);
    _initializerDefineProperty(this, "error", _descriptor7, this);
    this.config = getOwner(this).resolveRegistration('config:environment');
    this.initializeQrCodeView();
  }
  displayQrCode(code) {
    const output = document.getElementById('auth-app-qr-output');
    output.innerHTML = code.svg;
  }
  async initializeQrCodeView() {
    this.view = this.views.QR_CODE;
    if (!this.multipassfeClient.googleAuthDetails?.authenticator_key_base32) {
      try {
        this.initializingAuthAppEnrollSecret = true;
        await this.multipassfeClient.enrollTwoFactorGoogleAuthenticator();
      } catch (e) {
        switch (e.message) {
          case 'TEMPORARY_LOCKOUT':
            this.error = this.intl.t(this.args.tPrefix + this.lockoutErrorTLabel);
            break;
          default:
            this.logger.sentryError(e);
            this.error = this.intl.t(this.args.tPrefix + this.unknownErrorTLabel);
        }
      } finally {
        this.initializingAuthAppEnrollSecret = false;
      }
    }
    if (this.error) {
      return;
    }

    // Run after this.view change causes re-render to allow targeting qr element
    later(this, () => {
      const code = new MarketQRCodeEncoder(this.multipassfeClient.googleAuthDetails?.authenticator_key_uri, {
        border: false,
        styleBackground: ''
      });
      this.displayQrCode(code);
    });
  }
  setView(view) {
    this.view = view;
  }
  detailSelected(event) {
    if (event.detail.newSelectionValue) {
      this.args.setDetail(event.detail.newSelectionValue);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "locale", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "view", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.views.QR_CODE;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "initializingAuthAppEnrollSecret", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "error", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "initializeQrCodeView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeQrCodeView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "detailSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "detailSelected"), _class.prototype), _class);
export { TwoFactorEnrollAuthAppComponent as default };